export default {
  http: {
    timeout: 'Network delay, please try again'
  }
}
